import { useLingui } from "@lingui/react";
import FieldValuePair from "../FieldValuePair.tsx";
import type { SpecProps } from "./types.ts";

export const Owners = ({ owners }: SpecProps<"owners">) => {
  const { i18n } = useLingui();

  if (owners == null || owners === 0) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.owners",
    message: "Owners",
    comment: "Field for 'owners' in ad specification",
  });
  return <FieldValuePair field={field} value={owners} />;
};
